



//重构 area
export function getarea(obj) {
  let newarray = [];
  obj.map((res, i) => {
    let name = res
    var label = {
      label: name['name'],
      value: name['name'],
      children: []
    }
    newarray.push(label);
    name['cityList'].map((item, j) => {
      var city = {
        label: item['name'],
        value: item['name'],
        children: []
      };
      newarray[i]["children"].push(city);
      item['areaList'].map((val,k)=>{
        var area={
            label: val,
            value: val,
        }
        newarray[i]["children"][j]["children"].push(area);
      })

    })
  })
  return newarray
}



// WEBPACK FOOTER //
// ./src/api/area.js